import React, { useState } from "react";
import { isEmpty, orderBy } from "lodash";
import clsx from "clsx";
// components
// import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
// enums
import EViewType from "@/cms/enums/EViewType";
// types
import TRMDRTab from "../type";
// utilities
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";


const RMDRTab01 = ( props:TRMDRTab ) => {
    console.log("RMDRTab01.rendered", props);

    const [activeTab, setActiveTab] = useState<string>("");

    const toggle = (tab:string) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    if ( 
        !isEmpty(props.parentLanguageVersion) && props.parentLanguageVersion && 
        !isEmpty(props.parentLanguageVersion?.id) && props.parentLanguageVersion?.id && 
        props.parentLanguageVersion.viewType === EViewType.TAB 
    ) {
        let payloadChild = props.languageVersions?.filter((item) => item.parentId === props.parentLanguageVersion?.id);

        if ( isEmpty(payloadChild) ) return null;

        payloadChild = orderBy(payloadChild, ['order'],['asc']);
        if ( isEmpty(activeTab) ) setActiveTab(payloadChild[0].id);

        // return (
        //     <div className="project-single-tab clearfix">
        //         <ul className="nav">
        //             <Nav tabs>
        //                 {
        //                     payloadChild.map((item) => (
        //                         <NavItem>
        //                             <NavLink
        //                                 className={clsx({ active: activeTab === item.id })}
        //                                 onClick={() => { toggle(item.id); }}
        //                             >
        //                                 {item.name}
        //                             </NavLink>
        //                         </NavItem>
        //                     ))
        //                 }
        //             </Nav>
        //         </ul>

        //         <TabContent activeTab={activeTab}>
        //             {
        //                 payloadChild.map((item) => (
        //                     <TabPane tabId={item.id}>
        //                         <RMDRComponentSanitizer
        //                             languageVersion={item}
        //                             variant="div"
        //                             valueExpr="value"
        //                         />
        //                     </TabPane>
        //                 ))
        //             }
        //         </TabContent>
        //     </div>
        // )
    }

    return null;
}

const Component = React.memo(RMDRTab01, ( prevProps:TRMDRTab, nextProps:TRMDRTab ) => {
    console.log("RMDRTab01.memo", { prevProps, nextProps });
    return !( 
        prevProps.isLoading !== nextProps.isLoading 
        || prevProps.parentLanguageVersion !== nextProps.parentLanguageVersion
    );
});

export default Component;
